module.exports = "<div class=\"chart-table\" >\n    <div class=\"chart-cell\" id=\"chartParent\">\n        <canvas id=\"canvas\">{{ chart }}</canvas>\n    </div>\n</div>\n<div class=\"clearfix\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/chart.component.html
// module id = ./src/app/shared/components/chart/chart.component.html
// module chunks = main